import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { AccountInitPasswordResponse } from '@/repositories/generated';

const response: AccountInitPasswordResponse = {
  email: 'hoge@example.com',
  id: '111',
};

export const initPassword = http.patch(
  createMockEndpoint('/account/:id/init_password'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
